/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExperienceLevel } from './';
import {
    ExperienceLevelFromJSON,
    ExperienceLevelFromJSONTyped,
    ExperienceLevelToJSON,
} from './';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExperienceWithOrigin
 */
export interface ExperienceWithOrigin {
    /**
     * 
     * @type {Origin}
     * @memberof ExperienceWithOrigin
     */
    origin: Origin;
    /**
     * 
     * @type {ExperienceLevel}
     * @memberof ExperienceWithOrigin
     */
    experience: ExperienceLevel;
}

/**
 * Check if a given object implements the ExperienceWithOrigin interface.
 */
export function instanceOfExperienceWithOrigin(value: object): value is ExperienceWithOrigin {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('experience' in value) || value['experience'] === undefined) return false;
    return true;
}

export function ExperienceWithOriginFromJSON(json: any): ExperienceWithOrigin {
    return ExperienceWithOriginFromJSONTyped(json, false);
}

export function ExperienceWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': OriginFromJSON(json['origin']),
        'experience': ExperienceLevelFromJSON(json['experience']),
    };
}

export function ExperienceWithOriginToJSON(value?: ExperienceWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'origin': OriginToJSON(value['origin']),
        'experience': ExperienceLevelToJSON(value['experience']),
    };
}

